import { Row, Col, Stack, SubHeading } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { SourceItem as StyledSourceItem } from '../LearnerAIQuestionAnswer.styles';
import { type ContentTypes, type ParentTypes, SourceItem as SourceItemComponent } from './SourceItem';

export interface Source {
  id: string;
  title: string;
  type?: ParentTypes;
  content_id?: string;
  content_type: ContentTypes;
  parent_id?: string;
  slug?: string;
}

interface SourcesListProps {
  sources: Source[];
  variant: 'dropdown' | 'advanced';
  showTitle?: boolean;
}

export const SourcesList = ({ sources, variant, showTitle = true }: SourcesListProps) => {
  const SOURCES_TITLE = I18n.t('js.learner.ai_search.sources_title');

  if (sources.length === 0) {
    return null;
  }

  if (variant === 'dropdown') {
    // Horizontal layout for dropdown view
    return (
      <Row gapX={2} gapY={3}>
        {sources.map(({ id, type, title, content_id, content_type, parent_id, slug }) => (
          <Col xs="auto" key={id}>
            <SourceItemComponent
              id={id}
              type={type}
              title={title}
              contentId={content_id}
              contentType={content_type}
              parentId={parent_id}
              slug={slug}
            />
          </Col>
        ))}
      </Row>
    );
  }

  // Vertical layout for advanced view
  return (
    <Stack size={showTitle ? 3 : 2}>
      {showTitle && <SubHeading level="md">{SOURCES_TITLE}</SubHeading>}
      <div>
        {sources.map(({ id, type, title, content_id, content_type, parent_id, slug }, index) => (
          <StyledSourceItem key={id} isLast={index === sources.length - 1}>
            <SourceItemComponent
              id={id}
              type={type}
              title={title}
              contentId={content_id}
              contentType={content_type}
              parentId={parent_id}
              slug={slug}
            />
          </StyledSourceItem>
        ))}
      </div>
    </Stack>
  );
};
